import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  emailBuilders: [],
  emailBuildersUiMeta: [],
  emailBuilder: {},
})

// getters
const getters = {}

// actions
const actions = {
  listEmailBuilders({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListEmailBuilders{
            created_at
            invisible_id
            name
            title
            updated_at
          }
        }
      `,
      variables: {
        name: 'EmailBuilderListVo',
      }
    }).then(data => {
      commit('set', ['emailBuildersUiMeta', data.GetUiMeta])
      commit('setEmailBuilders', data.ListEmailBuilders)
      return true
    })
  },
  getEmailBuilder({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetEmailBuilder(id: $id){
            created_at
            id
            name
            title
            static_data
            style
            template
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(data => {
      commit('setEmailBuilder', data.GetEmailBuilder)
      return true
    })
  },
  addEmailBuilder(_, emailBuilder) {
    return gqlApi.query({
      query: `    
        mutation($input: EmailBuilderAddVo){
          AddEmailBuilder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: emailBuilder,
      },
    }).then(() => {
      return true
    })
  },
  updateEmailBuilder(_, emailBuilder) {
    return gqlApi.query({
      query: `    
        mutation($input: EmailBuilderUpdateVo){
          UpdateEmailBuilder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: emailBuilder,
      },
    }).then(() => {
      return true
    })
  },
  deleteEmailBuilder(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteEmailBuilder(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setEmailBuilder (state, emailBuilder) {
    state.emailBuilder = emailBuilder
  },
  setEmailBuilders (state, emailBuilders) {
    state.emailBuilders = emailBuilders
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}